module.exports = __webpack_public_path__ + "img/button_left.2476ea92.png";